declare namespace $ {

	type $bog_builderui_skin__lights_bog_music_app_1 = $mol_type_enforce<
		ReturnType< $bog_music_app['lights'] >
		,
		ReturnType< $bog_builderui_skin['lights'] >
	>
	type $bog_builderui_skin__base_bog_music_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_skin['base'] >
	>
	type $bog_builderui_skin__font_head_bog_music_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_builderui_skin['font_head'] >
	>
	type $mol_image__uri_bog_music_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_bog_music_app_5 = $mol_type_enforce<
		ReturnType< $bog_music_app['title'] >
		,
		ReturnType< $mol_image['title'] >
	>
	type $mol_view__sub_bog_music_app_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_app_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_app_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_app_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_icon__hint_bog_music_app_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_bog_music_app_11 = $mol_type_enforce<
		ReturnType< $bog_music_app['Wave_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_bog_music_app_12 = $mol_type_enforce<
		ReturnType< $bog_music_app['wave_mode'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_button_open__hint_bog_music_app_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['hint'] >
	>
	type $mol_button_open__accept_bog_music_app_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['accept'] >
	>
	type $mol_button_open__files_bog_music_app_15 = $mol_type_enforce<
		ReturnType< $bog_music_app['upload_files'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $bog_theme_toggle__theme_auto_bog_music_app_16 = $mol_type_enforce<
		ReturnType< $bog_music_app['Theme'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type $bog_music_account__font_size_bog_music_app_17 = $mol_type_enforce<
		ReturnType< $bog_music_app['font_size'] >
		,
		ReturnType< $bog_music_account['font_size'] >
	>
	type $bog_music_account__dev_bog_music_app_18 = $mol_type_enforce<
		ReturnType< $bog_music_app['dev'] >
		,
		ReturnType< $bog_music_account['dev'] >
	>
	type $bog_music_account__download_playlist_bog_music_app_19 = $mol_type_enforce<
		ReturnType< $bog_music_app['download_playlist'] >
		,
		ReturnType< $bog_music_account['download_playlist'] >
	>
	type $bog_music_account__download_playlist_status_bog_music_app_20 = $mol_type_enforce<
		ReturnType< $bog_music_app['download_playlist_status'] >
		,
		ReturnType< $bog_music_account['download_playlist_status'] >
	>
	type $bog_music_account__tg_hint_bog_music_app_21 = $mol_type_enforce<
		ReturnType< $bog_music_app['tg_hint'] >
		,
		ReturnType< $bog_music_account['tg_hint'] >
	>
	type $bog_music_account__tg_button_bog_music_app_22 = $mol_type_enforce<
		ReturnType< $bog_music_app['tg_button'] >
		,
		ReturnType< $bog_music_account['tg_button'] >
	>
	type $bog_music_account__tg_status_bog_music_app_23 = $mol_type_enforce<
		ReturnType< $bog_music_app['tg_status'] >
		,
		ReturnType< $bog_music_account['tg_status'] >
	>
	type $bog_music_account__tg_link_bog_music_app_24 = $mol_type_enforce<
		ReturnType< $bog_music_app['tg_link'] >
		,
		ReturnType< $bog_music_account['tg_link'] >
	>
	type $bog_music_account__fm_hint_bog_music_app_25 = $mol_type_enforce<
		ReturnType< $bog_music_app['fm_hint'] >
		,
		ReturnType< $bog_music_account['fm_hint'] >
	>
	type $bog_music_account__fm_button_bog_music_app_26 = $mol_type_enforce<
		ReturnType< $bog_music_app['fm_button'] >
		,
		ReturnType< $bog_music_account['fm_button'] >
	>
	type $bog_music_account__fm_status_bog_music_app_27 = $mol_type_enforce<
		ReturnType< $bog_music_app['fm_status'] >
		,
		ReturnType< $bog_music_account['fm_status'] >
	>
	type $bog_music_account__fm_link_bog_music_app_28 = $mol_type_enforce<
		ReturnType< $bog_music_app['fm_link'] >
		,
		ReturnType< $bog_music_account['fm_link'] >
	>
	type $bog_music_log_view__version_bog_music_app_29 = $mol_type_enforce<
		ReturnType< $bog_music_app['version_label'] >
		,
		ReturnType< $bog_music_log_view['version'] >
	>
	type $bog_feedback2_form__feedback_id_bog_music_app_30 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_feedback2_form['feedback_id'] >
	>
	type $mol_view__sub_bog_music_app_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_app_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_music_app_33 = $mol_type_enforce<
		ReturnType< $bog_music_app['beam_button'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_app_34 = $mol_type_enforce<
		ReturnType< $bog_music_app['beam_pull'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_music_app_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_music_playlists__page_bog_music_app_36 = $mol_type_enforce<
		ReturnType< $bog_music_app['page'] >
		,
		ReturnType< $bog_music_playlists['page'] >
	>
	type $bog_music_playlists__my_title_bog_music_app_37 = $mol_type_enforce<
		ReturnType< $bog_music_app['my_title'] >
		,
		ReturnType< $bog_music_playlists['my_title'] >
	>
	type $bog_music_playlists__archive_title_bog_music_app_38 = $mol_type_enforce<
		ReturnType< $bog_music_app['archive_title'] >
		,
		ReturnType< $bog_music_playlists['archive_title'] >
	>
	type $bog_music_playlists__list_dict_bog_music_app_39 = $mol_type_enforce<
		ReturnType< $bog_music_app['list_dict'] >
		,
		ReturnType< $bog_music_playlists['list_dict'] >
	>
	type $bog_music_tracks__track_keys_bog_music_app_40 = $mol_type_enforce<
		ReturnType< $bog_music_app['visible_keys'] >
		,
		ReturnType< $bog_music_tracks['track_keys'] >
	>
	type $bog_music_tracks__current_key_bog_music_app_41 = $mol_type_enforce<
		ReturnType< $bog_music_app['current_key'] >
		,
		ReturnType< $bog_music_tracks['current_key'] >
	>
	type $bog_music_tracks__play_key_bog_music_app_42 = $mol_type_enforce<
		ReturnType< $bog_music_app['play_key'] >
		,
		ReturnType< $bog_music_tracks['play_key'] >
	>
	type $bog_music_tracks__archive_mode_bog_music_app_43 = $mol_type_enforce<
		ReturnType< $bog_music_app['archive_mode'] >
		,
		ReturnType< $bog_music_tracks['archive_mode'] >
	>
	type $bog_music_tracks__reorder_to_bog_music_app_44 = $mol_type_enforce<
		ReturnType< $bog_music_app['reorder_to'] >
		,
		ReturnType< $bog_music_tracks['reorder_to'] >
	>
	type $bog_music_tracks__archive_key_bog_music_app_45 = $mol_type_enforce<
		ReturnType< $bog_music_app['archive_key'] >
		,
		ReturnType< $bog_music_tracks['archive_key'] >
	>
	type $bog_music_tracks__restore_key_bog_music_app_46 = $mol_type_enforce<
		ReturnType< $bog_music_app['restore_key'] >
		,
		ReturnType< $bog_music_tracks['restore_key'] >
	>
	type $bog_music_tracks__delete_key_bog_music_app_47 = $mol_type_enforce<
		ReturnType< $bog_music_app['delete_key'] >
		,
		ReturnType< $bog_music_tracks['delete_key'] >
	>
	type $bog_music_tracks__demote_key_bog_music_app_48 = $mol_type_enforce<
		ReturnType< $bog_music_app['demote_key'] >
		,
		ReturnType< $bog_music_tracks['demote_key'] >
	>
	type $mol_string__hint_bog_music_app_49 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_music_app_50 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__keyboard_bog_music_app_51 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_string__enter_bog_music_app_52 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['enter'] >
	>
	type $mol_button_major__title_bog_music_app_53 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_music_app_54 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_find'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__dom_name_bog_music_app_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__event_bog_music_app_56 = $mol_type_enforce<
		({ 
			submit( next?: ReturnType< $bog_music_app['tube_submit'] > ): ReturnType< $bog_music_app['tube_submit'] >,
		})  & ReturnType< $mol_view['event'] >
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_music_app_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_music_app_58 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $bog_music_tube_row__title_bog_music_app_59 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_title'] >
		,
		ReturnType< $bog_music_tube_row['title'] >
	>
	type $bog_music_tube_row__subtitle_bog_music_app_60 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_meta'] >
		,
		ReturnType< $bog_music_tube_row['subtitle'] >
	>
	type $bog_music_tube_row__status_bog_music_app_61 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_status_text'] >
		,
		ReturnType< $bog_music_tube_row['status'] >
	>
	type $bog_music_tube_row__cover_bog_music_app_62 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_cover'] >
		,
		ReturnType< $bog_music_tube_row['cover'] >
	>
	type $bog_music_tube_row__busy_bog_music_app_63 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_busy'] >
		,
		ReturnType< $bog_music_tube_row['busy'] >
	>
	type $bog_music_tube_row__play_bog_music_app_64 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_play'] >
		,
		ReturnType< $bog_music_tube_row['play'] >
	>
	type $bog_music_tube_row__get_bog_music_app_65 = $mol_type_enforce<
		ReturnType< $bog_music_app['tube_get'] >
		,
		ReturnType< $bog_music_tube_row['get'] >
	>
	type $bog_music_player__full_bog_music_app_66 = $mol_type_enforce<
		ReturnType< $bog_music_app['player_full'] >
		,
		ReturnType< $bog_music_player['full'] >
	>
	type $bog_music_player__open_bog_music_app_67 = $mol_type_enforce<
		ReturnType< $bog_music_app['player_open'] >
		,
		ReturnType< $bog_music_player['open'] >
	>
	type $bog_music_player__collapse_bog_music_app_68 = $mol_type_enforce<
		ReturnType< $bog_music_app['player_collapse'] >
		,
		ReturnType< $bog_music_player['collapse'] >
	>
	type $bog_music_player__queue_keys_bog_music_app_69 = $mol_type_enforce<
		ReturnType< $bog_music_app['visible_keys'] >
		,
		ReturnType< $bog_music_player['queue_keys'] >
	>
	type $bog_music_player__current_key_bog_music_app_70 = $mol_type_enforce<
		ReturnType< $bog_music_app['current_key'] >
		,
		ReturnType< $bog_music_player['current_key'] >
	>
	type $bog_music_nav__section_bog_music_app_71 = $mol_type_enforce<
		ReturnType< $bog_music_app['section'] >
		,
		ReturnType< $bog_music_nav['section'] >
	>
	type $bog_music_nav__dev_bog_music_app_72 = $mol_type_enforce<
		ReturnType< $bog_music_app['dev'] >
		,
		ReturnType< $bog_music_nav['dev'] >
	>
	export class $bog_music_app extends $mol_page {
		Skin( ): $bog_builderui_skin
		Theme( ): $bog_theme_auto
		Popup_fix( ): $bog_popup_plugin
		Tooltip( ): $bog_tooltip_plugin
		Brand_image( ): $mol_image
		Brand_name( ): $mol_view
		Brand( ): $mol_view
		Sync_status( ): $giper_baza_status
		nickname_label( ): string
		Nickname_label( ): $mol_view
		version_label( ): string
		Version( ): $mol_view
		Wave_icon( ): $mol_icon_chart_timeline_variant
		wave_mode( next?: boolean ): boolean
		Wave_toggle( ): $mol_check_icon
		upload_files( next?: readonly(File)[] ): readonly(File)[]
		Upload( ): $mol_button_open
		Theme_btn( ): $bog_theme_toggle
		scroll( next?: number ): number
		dev( next?: boolean ): boolean
		download_playlist( next?: any ): any
		download_playlist_status( ): string
		tg_hint( ): string
		tg_button( ): string
		tg_status( ): string
		tg_link( next?: any ): any
		fm_hint( ): string
		fm_button( ): string
		fm_status( ): string
		fm_link( next?: any ): any
		Account( ): $bog_music_account
		Logs( ): $bog_music_log_view
		Feedback( ): $bog_feedback2_form
		share_toast_text( ): string
		Share_toast( ): $mol_view
		beam_text( ): string
		Beam_text( ): $mol_view
		beam_button( ): string
		beam_pull( next?: any ): any
		Beam_pull( ): $mol_button_minor
		Beam_bar( ): $mol_view
		page( next?: string ): string
		my_title( ): string
		archive_title( ): string
		list_dict( ): Record<string, any>
		Tabs( ): $bog_music_playlists
		visible_keys( ): readonly(any)[]
		current_key( next?: string ): string
		play_key( next?: any ): any
		archive_mode( ): boolean
		reorder_to( next?: any ): any
		archive_key( next?: any ): any
		restore_key( next?: any ): any
		delete_key( next?: any ): any
		demote_key( next?: any ): any
		Tracks( ): $bog_music_tracks
		tube_submit( next?: any ): any
		tube_query( next?: string ): string
		Tube_query( ): $mol_string
		tube_find( next?: any ): any
		Tube_find( ): $mol_button_major
		Tube_bar( ): $mol_view
		tube_rows( ): readonly(any)[]
		Tube_list( ): $mol_list
		tube_title( id: any): string
		tube_meta( id: any): string
		tube_status_text( id: any): string
		tube_cover( id: any): string
		tube_busy( id: any): boolean
		tube_play( id: any, next?: any ): any
		tube_get( id: any, next?: any ): any
		Tube_row( id: any): $bog_music_tube_row
		player_full( ): boolean
		player_open( next?: any ): any
		player_collapse( next?: any ): any
		Player( ): $bog_music_player
		section( next?: string ): string
		Nav( ): $bog_music_nav
		plugins( ): readonly(any)[]
		lights( ): string
		font_size( next?: string ): string
		attr( ): ({ 
			'bog_music_font': ReturnType< $bog_music_app['font_size'] >,
		})  & ReturnType< $mol_page['attr'] >
		title( ): string
		Title( ): ReturnType< $bog_music_app['Brand'] >
		tools( ): readonly(any)[]
		body_scroll_top( next?: ReturnType< $bog_music_app['scroll'] > ): ReturnType< $bog_music_app['scroll'] >
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map